import { Center } from "@chakra-ui/react"

export const EmptyMessage: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  return (
    <Center bg="#fafafa" padding={24} paddingY={24} color="gray.600" fontWeight={500}>
      {children}
    </Center>
  )
}
